"use strict";

exports.__esModule = true;
exports.Item = void 0;

var _utils = require("./utils");

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Item = /*#__PURE__*/function () {
  /* @ngInject */
  function Item(config) {
    this.style = {};
    this.visibility = {};
    config = config || {};

    if (!config.dto) {
      console.error('Item has no DTO', config);
      config.dto = {};
    }

    this.config = config;
    this.dto = config.dto;
    this.idx = config.idx;
    this.inGroupIdx = config.inGroupIdx;
    this.container = config.container;
    this.cubeType = 'fill';

    if (config.styleParams) {
      var _config = config,
          styleParams = _config.styleParams;
      this.cubeType = styleParams.cubeType;
      this.cubeImages = styleParams.cubeImages;
      this._cubeRatio = styleParams.cubeRatio;
      this.rotatingCropRatios = styleParams.rotatingCropRatios;
      this.smartCrop = styleParams.smartCrop;
      this.cropOnlyFill = styleParams.cropOnlyFill;
      this.imageMargin = styleParams.imageMargin;
      this.galleryMargin = styleParams.galleryMargin;
      this.floatingImages = styleParams.floatingImages;
      this.smartCrop = styleParams.smartCrop;
    }

    this._groupOffset = {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    };
    this._group = {};

    this.calcPinOffset = function () {
      return 0;
    };

    this.resize(1);
  }

  var _proto = Item.prototype;

  _proto.fixMetadataVerticalVideoRatio = function fixMetadataVerticalVideoRatio(metadata) {
    if (metadata.qualities && metadata.qualities[0]) {
      //fix incorrect width height for vertical videos
      var qualities = metadata.qualities;
      var _qualities = qualities[qualities.length - 1],
          height = _qualities.height,
          width = _qualities.width;
      metadata.height = height;
      metadata.width = width;
    }
  };

  _proto.resize = function resize(scaleOrDimensions) {
    var scale = 1;

    if (scaleOrDimensions === false) {
      return;
    } else if (scaleOrDimensions > 0) {
      scale = scaleOrDimensions;
    } else if (typeof scaleOrDimensions === 'object') {
      if (scaleOrDimensions.width) {
        var w = Math.max(1, scaleOrDimensions.width);
        scale = w / this.width;
      } else if (scaleOrDimensions.height) {
        var h = Math.max(1, scaleOrDimensions.height);
        scale = h / this.height;
      }
    }

    this.width *= scale;
    this.height *= scale;
    this.resized = true;
    return this;
  };

  _proto.pinToCorner = function pinToCorner(cornerName, pinAfter) {
    var _this = this;

    if (pinAfter === void 0) {
      pinAfter = false;
    }

    var isTop = cornerName.indexOf('top') >= 0;
    var isLeft = cornerName.indexOf('left') >= 0;
    this.style.top = isTop ? 0 : 'auto';
    this.style.bottom = isTop ? 'auto' : 0;
    this.style.left = isLeft ? 0 : 'auto';
    this.style.right = isLeft ? 'auto' : 0;
    this.pin = cornerName;
    this.isPinnedTop = isTop;
    this.isPinnedLeft = isLeft;
    this.pinAfter = pinAfter;
    this.pinAfterType = isTop ? 'top' : isLeft ? 'left' : '';

    this.calcPinOffset = function (groupSize, dir) {
      if (!_this.pinAfter) {
        return 0;
      } else if (_this.pin === dir) {
        //this is used only for 3h/3v group types - to calc the offset of the middle item
        var m = _this.imageMargin; // return ((groupSize - 6 * m) * this.pinOffset + 2 * m);

        if (dir === 'top') {
          return _this.pinAfter.height + 2 * m;
        } else if (dir === 'left') {
          return _this.pinAfter.width + 2 * m;
        } else {
          return 0;
        } // return ((groupSize - 6 * m) * this.pinOffset + 4 * m);

      } else {
        return 0;
      }
    };
  };

  _proto.setPosition = function setPosition(position) {
    this.style.position = position;
  };

  _proto.getPosition = function getPosition(pos) {
    return parseInt(pos, 10) >= 0 ? pos : 'auto';
  };

  _createClass(Item, [{
    key: "top",
    get: function get() {
      return this.getPosition(this.style.top);
    }
  }, {
    key: "left",
    get: function get() {
      return this.getPosition(this.style.left);
    }
  }, {
    key: "right",
    get: function get() {
      return this.getPosition(this.style.right);
    }
  }, {
    key: "bottom",
    get: function get() {
      return this.getPosition(this.style.bottom);
    }
  }, {
    key: "group",
    set: function set(group) {
      Object.assign(this._group, group);
    },
    get: function get() {
      return this._group;
    }
  }, {
    key: "groupOffset",
    set: function set(offset) {
      Object.assign(this._groupOffset, offset);
    }
  }, {
    key: "offset",
    get: function get() {
      var offset = {
        top: this._groupOffset.top + (this.isPinnedTop ? this.calcPinOffset(this._group.height, 'top') : this._group.height - this.outerHeight) || 0,
        left: this._groupOffset.left + (this.isPinnedLeft ? this.calcPinOffset(this._group.width, 'left') : this._group.width - this.outerWidth) || 0
      };
      offset.right = offset.left + this.width;
      offset.bottom = offset.top + this.height;
      return offset;
    }
  }, {
    key: "transform",
    get: function get() {
      if (this.floatingImages > 0) {
        var m = this.imageMargin;
        var g = this.galleryMargin;
        var spaceLeft = this.offset.left > 0 ? m : g;
        var spaceRight = this.container.galleryWidth - this.offset.right > 2 * m ? m : g;
        var spaceUp = this.offset.top > 0 ? m : g;
        var spaceDown = this.container.galleryHeight - this.offset.bottom > 2 * m ? m : g;
        var horizontalShift = _utils.utils.hashToInt(this.hash + this.offset.right + 'x', -1 * spaceLeft, spaceRight) * this.floatingImages;
        var verticalShift = _utils.utils.hashToInt(this.hash + this.offset.top + 'y', -1 * spaceUp, spaceDown) * this.floatingImages;
        return {
          transform: "translate3d(" + horizontalShift + "px, " + verticalShift + "px, 0)"
        };
      } else {
        return {};
      }
    }
  }, {
    key: "id",
    get: function get() {
      return this.dto.id || this.dto.photoId || this.dto.itemId;
    },
    set: function set(id) {
      this.dto.itemId = this.dto.photoId = this.dto.id = id;
    }
  }, {
    key: "hash",
    get: function get() {
      return this.dto.hash || this.dto.mediaUrl || this.dto.id;
    }
  }, {
    key: "maxWidth",
    get: function get() {
      return this.dto.width || this.dto.w;
    },
    set: function set(w) {
      this.dto.width = w;
    }
  }, {
    key: "outerWidth",
    get: function get() {
      return this.width + 2 * this.margins;
    }
  }, {
    key: "orgWidth",
    get: function get() {
      return this.style.width || this.dto.width || this.dto.w || 1; //make sure the width / height is not undefined (crashes the gallery)
    }
  }, {
    key: "width",
    get: function get() {
      var width;

      if (this.cubeImages && this.ratio >= this.cubeRatio) {
        width = this.style.cubedWidth || this.orgHeight * this.cubeRatio;
      } else {
        width = this.orgWidth;
      }

      return Math.max(width, 1);
    },
    set: function set(w) {
      this.style.cubedWidth = this.style.width = Math.max(1, w);
    }
  }, {
    key: "outerHeight",
    get: function get() {
      return this.height + 2 * this.margins;
    }
  }, {
    key: "orgHeight",
    get: function get() {
      return this.style.height || this.dto.height || this.dto.h || 1; //make sure the width / height is not undefined (creashes the gallery)
    }
  }, {
    key: "height",
    get: function get() {
      var height;

      if (this.cubeImages && this.ratio < this.cubeRatio) {
        height = this.style.cubedHeight || this.orgWidth / this.cubeRatio;
      } else {
        height = this.orgHeight;
      }

      return Math.max(height, 1);
    },
    set: function set(h) {
      this.style.cubedHeight = this.style.height = Math.max(1, h);
    }
  }, {
    key: "maxHeight",
    get: function get() {
      return this.dto.height || this.dto.h;
    },
    set: function set(h) {
      h = this.dto.height;
    }
  }, {
    key: "margins",
    get: function get() {
      return this.imageMargin || 0;
    },
    set: function set(m) {
      this.imageMargin = m;
    }
  }, {
    key: "cubeRatio",
    get: function get() {
      var _this2 = this;

      var ratio;

      if (this.rotatingCropRatios && this.rotatingCropRatios.length > 0) {
        var cropRatiosArr = String(this.rotatingCropRatios).split(',');
        ratio = cropRatiosArr[this.idx % cropRatiosArr.length];
      }

      if (!ratio && typeof this._cubeRatio === 'function') {
        ratio = this._cubeRatio();
      }

      if (!ratio && this.cropOnlyFill && this.cubeType === 'fit') {
        ratio = this.ratio;
      }

      if (!ratio) {
        ratio = this._cubeRatio || this.ratio;
      }

      if (this.dynamicCropRatios !== null && typeof ratio === 'string') {
        if (!this.dynamicCropRatios) {
          var dynamicCropRegex = /^\d*\.?\d*(%|px)\/\d*\.?\d*(%|px)$/;
          var match = dynamicCropRegex.exec(ratio);

          if (match) {
            this.dynamicCropRatios = ratio.split('/').map(function (val, idx) {
              if (val.indexOf('%') > 0) {
                return {
                  type: '%',
                  val: parseFloat(val.replace('%', '')) / 100,
                  dim: idx === 0 ? 'galleryWidth' : 'galleryHeight'
                };
              } else {
                return {
                  type: 'px',
                  val: parseInt(val.replace('px', ''))
                };
              }
            });
          } else {
            this.dynamicCropRatios = null;
          }
        }

        if (this.dynamicCropRatios) {
          var dynamicCropRatio = this.dynamicCropRatios.map(function (r) {
            if (r.type === '%') {
              var dim = _this2.container[r.dim] + (r.dim === 'galleryHeight' ? _this2.imageMargin : 0);
              var relativeDim = r.val * dim - 2 * _this2.imageMargin;
              return relativeDim;
            } else {
              return r.val;
            }
          });
          ratio = dynamicCropRatio[0] / dynamicCropRatio[1];
        }
      }

      ratio = Number(ratio);

      if (this.smartCrop === true) {
        if (this.isPortrait) {
          return Math.min(ratio, 1 / ratio);
        } else {
          return Math.max(ratio, 1 / ratio);
        }
      } else {
        return ratio;
      }
    },
    set: function set(ratio) {
      if (typeof this._cubeRatio === 'number') {
        this._cubeRatio = ratio;
        this.style.cubedHeight = this.style.cubedWidth = 0;
      }
    }
  }, {
    key: "orientation",
    get: function get() {
      return this.ratio < 0.999 ? 'portrait' : 'landscape'; //make sure that almost square images get the same treatment
    }
  }, {
    key: "isPortrait",
    get: function get() {
      return this.orientation === 'portrait';
    }
  }, {
    key: "isLandscape",
    get: function get() {
      return this.orientation === 'landscape';
    }
  }, {
    key: "ratio",
    get: function get() {
      if (!this.orgRatio) {
        this.orgRatio = this.orgWidth / this.orgHeight;
      }

      return this.orgRatio;
    },
    set: function set(r) {
      this.orgRatio = r;
    }
  }, {
    key: "scheme",
    get: function get() {
      return {
        id: this.id,
        idx: this.idx,
        inGroupIdx: this.inGroupIdx,
        dto: this.dto,
        type: this.type,
        style: this.style,
        width: this.width,
        maxWidth: this.maxWidth,
        outerWidth: this.outerWidth,
        height: this.height,
        maxHeight: this.maxHeight,
        outerHeight: this.outerHeight,
        margins: this.margins,
        ratio: this.ratio,
        cropRatio: this.cubeRatio,
        isCropped: this.cubeImages,
        cropType: this.cubeType,
        group: this.group,
        offset: this.offset,
        groupOffset: this._groupOffset,
        transform: this.transform,
        orientation: this.orientation,
        isPortrait: this.isPortrait,
        isLandscape: this.isLandscape,
        visibility: this.visibility
      };
    }
  }]);

  return Item;
}();

exports.Item = Item;